

import { proveedorApi } from "../../apis";
import { useProveedoresStore } from "../../stores/productos/proveedores";

import Swal from "sweetalert2";





export const proveedorXID = async(id) => {
    try {
        if( id === 'new') return null;
        const { data } = await proveedorApi.get(`/xid/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const listadoTodosProveedores = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await proveedorApi.get('/todos', { params });
        useProveedoresStore.setState({ totalProveedores : data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const listadoProveedoresSelect = async() => {
    try {
        const { data } = await proveedorApi.get('/todos/select');
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const startSavingProveedor = async( datos ) => {
    try {
        const isUpdate = datos.id !== 'new';
        const { data } = isUpdate 
            ? await proveedorApi.put(`/${datos.id}`, datos)
            : await proveedorApi.post('/new', datos);
        
        await Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data?.msg || '', 'error');
        return false;
    }
} 




export const deleteProveedor = async(id) => {
    try {
        const { data } = await proveedorApi.delete(`/${id}`);
        Swal.fire('Error', data.msg, 'success');
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}